import React, { useState } from "react";
import TitleBar from "../../partials/content/TitleBar";
import httpService from "../../../services/httpServices/httpServices";
import helperSpinner from "../../../helpers/spinner";
import validationResetPassword from "../../../validtions/forms/auth/edit-password";

export default function EditEmail() {
  const [message, setMessage] = useState();

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const editPassword = async () => {
    const dataForm = getDataForm();
    const resultValidationResetPassword = validationResetPassword(dataForm);
    if (resultValidationResetPassword != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: resultValidationResetPassword,
        class_icon: "fa fa-exclamation-triangle",
      });
      return;
    }

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const result = await sendRequestEditPassword(dataForm);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!result) {
      return;
    }

    setMessage({
      type_class: "alert alert-success",
      text: "ویرایش رمز عبور با موفقیت انجام شد.",
      class_icon: "fa fa-info",
    });
  };

  const getDataForm = () => {
    return {
      password: document.querySelector("#password").value,
      repeat_password: document.querySelector("#repeat-password").value,
    };
  };

  const sendRequestEditPassword = async (dataForm) => {
    const headersRequest = getHeaderRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/auth/edit-password",
        dataForm,
        headersRequest
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger ",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle pl-2 ",
      });
      return false;
    }

    return true;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  return (
    <div className="container-fluid pt-3 container-all-site-user-advertiser">
      <div className="row">
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-lg-12 p-0">
          <TitleBar title="ویرایش کلمه عبور" />

          <section className="content pt-5">
            <div className="card">
              <div className="card-body">
                {messageTag}
                <div className="alert alert-warning ">
                  <p>
                    <i className="fa fa-info pl-2"></i>
                    توجه داشته باشید :{" "}
                  </p>
                  <ul className="pr-3">
                    <li>
                      <p>
                        کلمه عبور شما حداقل باید دارای یک حرف و یک عدد باشد.
                      </p>
                    </li>
                  </ul>
                </div>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    editPassword();
                  }}
                  className="d-lg-flex align-items-lg-end"
                >
                  <div className="form-group m-0">
                    <label>کلمه عبور</label>
                    <input
                      type="password"
                      className="form-control"
                      id="password"
                      placeholder="کلمه عبور"
                    />
                  </div>
                  <div className="form-group m-0 px-lg-3 py-3 py-lg-0">
                    <label>تکرار کلمه عبور </label>
                    <input
                      type="password"
                      className="form-control"
                      id="repeat-password"
                      placeholder="تکرار کلمه عبور"
                    />
                  </div>
                  <div>
                    <button type="submit" className="btn btn-success">
                      ویرایش کلمه عبور
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
